/** Dashboard tab navigation reloads /api/dashboard/stats. Other tabs do not. */
export function tabRefreshLoadsDashboardStats(effectiveTab: string): boolean {
  return effectiveTab === 'dashboard';
}

/** Same loading/error behavior as the existing App fetchStats path. */
export async function fetchDashboardStatsJson(): Promise<any | undefined> {
  try {
    const res = await fetch('/api/dashboard/stats', { credentials: 'include' });
    if (res.ok) {
      return await res.json();
    }
  } catch (err) {
    console.error('Failed to fetch dashboard stats:', err);
  }
  return undefined;
}
